<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary"> Reset Password</h5>
                  <p>Reset-Password with HESLB.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img alt="" class="img-fluid" src="assets/images/profile-img.png">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img alt="" class="rounded-circle" height="34" src="assets/images/logo.png">
                  </span>
                </div>
              </a>
            </div>

            <form (ngSubmit)="onSubmit()" [formGroup]="resetForm" class="needs-validation" name="resetForm" novalidate>

              <!--              <ngb-alert type="danger" *ngIf="error" [dismissible]="false">{{ error }}</ngb-alert>-->
              <div class="mb-3">
                <label for="index_no">Index-Number</label>
                <input [ngClass]="{'is-invalid': (f.index_no.dirty || f.index_no.touched) && f.index_no.errors}" class="form-control" formControlName="index_no"
                       id="index_no"
                       placeholder="Please Enter Your Form-4 Index-Number(Username)" type="text"/>
                <div *ngIf="(f.index_no.dirty || f.index_no.touched) && f.index_no.errors" class="invalid-feedback">
                  <div *ngIf="f.index_no?.errors?.required">Your Index Number Is Required</div>
                  <div *ngIf="f.index_no?.errors?.isValidIndexNo">Please Enter A Valid Index Number</div>
                </div>
              </div>
              <ng-container *ngIf="beneficiary_details">
                <div class="row text-center p-1"><span
                  class="text-success">{{beneficiary_details?.first_name}} {{beneficiary_details?.middle_name}}</span>
                </div>
                <div class="mb-3">
                  <label for="last_name">Please Enter Your Last Name</label>
                  <input [ngClass]="{'is-invalid': (f.last_name.dirty || f.last_name.touched) && f.last_name.errors}" class="form-control" formControlName="last_name"
                         id="last_name"
                         placeholder="Please Enter Your Last Name" type="text"/>
                  <div *ngIf="(f.last_name.dirty || f.last_name.touched) && f.last_name.errors"
                       class="invalid-feedback">
                    <div *ngIf="f.last_name?.errors?.required">Your Last Name Is Required</div>
                    <div *ngIf="f.last_name?.errors?.stringCompare">Last Name's Dont Match</div>
                  </div>
                </div>
                <div class="mb-3" *ngIf="has_benef_reg_phone; else has_no_phone_no">
                  <label for="phone_no">Please Enter The Phone Number Used In Your Account Registration</label>
                  <input [ngClass]="{'is-invalid': (f.phone_no.dirty || f.phone_no.touched) && f.phone_no.errors}" class="form-control" formControlName="phone_no"
                         id="phone_no"
                         placeholder="Please Enter Your Phone Number" type="text"/>
                  <div *ngIf="(f.phone_no.dirty || f.phone_no.touched) && f.phone_no.errors" class="invalid-feedback">
                    <div *ngIf="f.phone_no?.errors?.required">Your Phone Number Is Required</div>
                    <div *ngIf="f.phone_no?.errors?.validPhoneNoCompare">Phone Number's Don't Match</div>
                  </div>
                </div>
                <ng-template #has_no_phone_no>
                  <div class="mb-3">
                    <label for="email">Please Enter The Email Address Used In Your Account Registration</label>
                    <input [ngClass]="{'is-invalid': (f.email.dirty || f.email.touched) && f.email.errors}" class="form-control" formControlName="email"
                           id="email"
                           placeholder="Please Enter Your Email Address" type="text"/>
                    <div *ngIf="(f.email.dirty || f.email.touched) && f.email.errors" class="invalid-feedback">
                      <div *ngIf="f.email?.errors?.required">Your Email Address Is Required</div>
                      <div *ngIf="f.email?.errors?.stringCompare">Email's Don't Match</div>
                    </div>
                  </div>
                </ng-template>

                <ng-container *ngIf="!(f.phone_no?.errors) && !(f.last_name?.errors) && !(f.email?.errors)">
                  <div class="mb-3">
                    <label for="password">Please Enter Your New Password</label>
                    <input [ngClass]="{'is-invalid': (f.password.dirty || f.password.touched) && f.password.errors}" class="form-control" formControlName="password"
                           id="password"
                           placeholder="Please Enter Your New Password" type="password"/>
                    <div *ngIf="(f.password.dirty || f.password.touched) && f.password.errors" class="invalid-feedback">
                      <div *ngIf="f.password?.errors?.required">Your New Password Is Required</div>
                    </div>
                  </div>
                </ng-container>

              </ng-container>

              <div class="text-end">
                <button [ladda]="loadingChangePassword" class="btn btn-primary w-md" type="submit" [disabled]="resetForm?.invalid">Reset Password</button>
              </div>
            </form>

          </div> <!-- end card-body-->
        </div>
        <!-- end card -->
        <div class="mt-5 text-center">
          <p>Remember It ? <a class="fw-medium text-primary" routerLink="/account/login"> Sign In here</a></p>
          <p>© {{year}} HESLB. All Rights Reserved</p>
        </div>

      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
<!-- end page -->
